// extracted by mini-css-extract-plugin
module.exports = {"outer-container":"WidePictures_outer-container__073OT","image":"WidePictures_image__wZ7Oe","load":"WidePictures_load___O9Ce"};